import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}

/**
 * Temporary route repair for the legacy PageFly cache on /pages/about-us.
 * Shopify can continue serving a stale PageFly page_cache even after the page
 * template is reassigned. This keeps the public URL stable while rendering the
 * restored Shopify about-us template in the main content area.
 */
(function restoreAboutUsFromTemplateView() {
  if (window.location.pathname.replace(/\/$/, '') !== '/pages/about-us') return;
  if (window.location.search.includes('view=about-us')) return;

  const main = document.querySelector('#MainContent');
  if (!main || main.querySelector('.about-editorial')) return;

  const pageText = document.body?.textContent || '';
  if (!pageText.includes('In 2021, SIBRILLE lamp was founded')) return;

  fetch('/pages/about-us?view=about-us', { credentials: 'same-origin' })
    .then((response) => {
      if (!response.ok) throw new Error(`About template request failed: ${response.status}`);
      return response.text();
    })
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const restoredMain = doc.querySelector('#MainContent');
      if (!restoredMain) return;

      main.replaceChildren(...Array.from(restoredMain.childNodes).map((node) => document.importNode(node, true)));
      if (doc.title) document.title = doc.title;
      document.documentElement.classList.add('sibrille-about-us-restored-client');
    })
    .catch(() => {
      document.documentElement.classList.add('sibrille-about-us-restore-failed');
    });
})();
